//@flow

import React from 'react';

type Props = {
  size?: number,
  w?: number,
  h?: number,
  strokeWidth?: number,
};

export default function Discount({size, w, h, strokeWidth}: Props) {
  const width = w || size || 24;
  const height = h || size || 24;
  const strokeWidthRing = strokeWidth || 1.25;
  const strokeWidthDoth = strokeWidthRing * 1.6;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.6412 4.59617C2.6412 3.51613 3.5163 2.64103 4.59634 2.64017H5.48614C6.00238 2.64017 6.497 2.43523 6.86365 2.07205L7.48538 1.44944C8.2472 0.6833 9.48549 0.679841 10.2516 1.44166L10.2525 1.44253L10.2603 1.44944L10.8829 2.07205C11.2495 2.43609 11.7441 2.64017 12.2604 2.64017H13.1493C14.2294 2.64017 15.1053 3.51527 15.1053 4.59617V5.48424C15.1053 6.00048 15.3094 6.49597 15.6734 6.86261L16.2961 7.48521C17.0622 8.24704 17.0665 9.48532 16.3047 10.2515L16.3038 10.2523L16.2961 10.2601L15.6734 10.8827C15.3094 11.2485 15.1053 11.7431 15.1053 12.2594V13.1492C15.1053 14.2292 14.2302 15.1043 13.1502 15.1043H13.1493H12.2587C11.7424 15.1043 11.2469 15.3092 10.8812 15.6733L10.2586 16.295C9.49759 17.0612 8.26017 17.0655 7.49403 16.3054C7.49317 16.3045 7.4923 16.3037 7.49144 16.3028L7.48365 16.295L6.86192 15.6733C6.49614 15.3092 6.00065 15.1052 5.48441 15.1043H4.59634C3.5163 15.1043 2.6412 14.2292 2.6412 13.1492V12.2576C2.6412 11.7414 2.43626 11.2468 2.07221 10.881L1.45048 10.2584C0.684333 9.49743 0.680009 8.26001 1.44097 7.49386C1.44097 7.493 1.44183 7.49213 1.4427 7.49127L1.45048 7.48349L2.07221 6.86088C2.43626 6.49424 2.6412 5.99962 2.6412 5.48252V4.59617"
        stroke="currentColor"
        strokeWidth={strokeWidthRing}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.65039 11.0951L11.0951 6.65039"
        stroke="currentColor"
        strokeWidth={strokeWidthRing}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.03 11.0334H11.0378"
        stroke="currentColor"
        strokeWidth={strokeWidthDoth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.70581 6.70922H6.7136"
        stroke="currentColor"
        strokeWidth={strokeWidthDoth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
